export const TEXTS = {
  MEASUREMENT_FOR: (name = '') => `Measurements for ${name}`,
  SELECT_SIZE: 'Select Size',
  SIZE_GUIDE: 'Size Guide',
};

export const TRACKING_KEY = 'sizeGuideClick:selectSize';
